<template>
  <!--
    The line a column's word is printed on, when not a reading the Edition
    prints for it (ORIGINS names each); with the witnesses that read or credit
    it, and "= 𝔐" when its reading is marked as agreeing with the Hebrew.
  -->
  <span v-if="origin !== 'head'" class="origin-badge" :class="origin" :title="title"
    >{{ named.badge }}<span v-if="witnesses.length" class="witnesses">
      {{ witnesses.join(' ') }}</span
    ><span v-if="agreesWithMt" class="agrees" title="Marked “= 𝔐”: the reading agrees with the Hebrew"> = 𝔐</span></span
  >
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue'
import { Origin, ORIGINS } from '../api'

export default defineComponent({
  name: 'OriginBadge',
  props: {
    origin: { type: String as PropType<Origin>, required: true },
    witnesses: { type: Array as PropType<string[]>, default: () => [] },
    agreesWithMt: { type: Boolean, default: false },
  },
  setup(props) {
    const named = computed(() => ORIGINS[props.origin])
    const title = computed(() => named.value.title)
    return { named, title }
  },
})
</script>

<style lang="scss" scoped>
@import '@/_colors';

.origin-badge {
  margin-left: 0.35em;
  font-size: 0.7rem;
  padding: 0 0.3rem;
  border-radius: 3px;
  border: 1px solid $border;
  color: $text-light;
  white-space: nowrap;

  .witnesses {
    margin-left: 0.3em;
    font-style: normal;
  }
}
</style>
